define([
    "jquery",
    "underscore",
    "backbone",
    "e_calendar"
], function ($, _, Backbone, eCalendar) {
    return Backbone.View.extend({
        el: '#content_layout',

        initialize: function () {
            eCalendar();
        }
    });
});
